import { createApp } from 'vue';
import globals from '@/globals';
import root from '@/view/vue/index.vue';
import router from '@/router';
import store from '@/store';

const app = createApp(root);

app.use(store);
app.use(router);

/** initialize global vue plugins, components, directives, filters, and mixins */
globals.initialize(app);

app.mount('#app');


export default app;
